/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IUserInputOneSignalUserDeviceAssociation,
} from '../types/request.types'
import {
  IGenericJSONMessage,
  IUserOutputPusherAuthHeaderValue,
} from '../types/response.types'

export default new class UserAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_PusherAuthHeaderValue(
  ): Promise<IUserOutputPusherAuthHeaderValue> {
    return await this.get({
      url: `/user/pusher-auth/header-value`,
    })
  }
  /****** POST methods *****/
  public async post_OneSignalUserDeviceAssociation(
    data: IUserInputOneSignalUserDeviceAssociation,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/user/one-signal/user-device-association`,
      data,
    })
  }
}()
